import React from 'react';
import PreferencesSection from '../PreferencesSection';
import PropTypes from 'prop-types';
import css from './ProfileSettings.scss';
import { getLoginPageOptions } from '../selectionOptions';
import classnames from 'classnames';
import { SFEntityID, StaffProfilePrivileges } from 'utils/types';
import ShareLinks from './ShareLinks';
import Select from 'common/StyledSelect';
import { find } from 'lodash';

const ProfileSettings = ({ appointmentLinkAvailable, homePage, isIE, privileges, profileLinkAvailable, setValue, userId }) => {
    const loginPageOptions = getLoginPageOptions(privileges);
    return (
        <PreferencesSection isStaff
                            className={classnames(css['profile-settings'], { [css.ie]: isIE })}
                            headerText="Profile Settings"
                            descriptionText="Control your login page and shared links.">
            <div>
                <label htmlFor="preferredLogin">Preferred Login Page</label>
                <Select id="preferredLogin"
                        ariaLabel="Preferred Login Page"
                        className={css['preferred-login']}
                        onChange={newHomePage => setValue({ homePage: newHomePage.value })}
                        options={loginPageOptions}
                        value={find(loginPageOptions, ['value', homePage])} />
                { privileges.canShareLinks &&
                    <ShareLinks appointmentLinkAvailable={appointmentLinkAvailable}
                                profileLinkAvailable={profileLinkAvailable}
                                setValue={setValue}
                                userId={userId} />
                }
            </div>
        </PreferencesSection>
    )
};

ProfileSettings.propTypes = {
    appointmentLinkAvailable: PropTypes.bool,
    homePage: PropTypes.string,
    isIE: PropTypes.bool,
    privileges: StaffProfilePrivileges,
    profileLinkAvailable: PropTypes.bool,
    setValue: PropTypes.func.isRequired,
    userId: SFEntityID.isRequired
};

export default ProfileSettings;
